var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tab-change"},_vm._l((_vm.changedOrderList),function(item){return _c('div',{key:item.value,staticClass:"tab-item",class:{ active: item.value === _vm.activeIndex },on:{"click":function($event){return _vm.tabChange(item.value)}}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }